module.exports = __webpack_public_path__ + "static/img/person3.1e01218.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person3.png
// module id = Nf4B
// module chunks = 1